"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSitemapPageForEdit = exports.getDomainForSitemap = exports.getFilterForSitemap = exports.getPagesForSitemapIndex = exports.getAddPageToSitemapModalOpen = exports.getEditPageUrlsTableIndex = exports.getIsEditPageUrlsTableOpen = exports.getIsEditPageUrlsOpen = exports.getPageForUrlEdit = exports.getOldDomainLanguage = exports.getNewDomainLanguage = exports.getEditPageOptionsModalOpen = exports.getIsUpdatePageUrlModalOpen = exports.getIsRedirectToAffectedPagesModalOpen = exports.getIsEditDomainLanguageModalOpen = exports.getDomainForLanguageEdit = void 0;

var _reselect = require("reselect");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _interactions = require("../constants/interactions");

var getInteractions = function getInteractions(state) {
  return state.modules[_UrlPathParams.MARKETING][_UrlPathParams.DOMAINS].interactions;
};

var getInteractionsProperty = function getInteractionsProperty(property) {
  return (0, _reselect.createSelector)([getInteractions], function (interactions) {
    return interactions.get(property);
  });
};

var getDomainForLanguageEdit = getInteractionsProperty(_interactions.DOMAIN_FOR_LANGUAGE_EDIT);
exports.getDomainForLanguageEdit = getDomainForLanguageEdit;
var getIsEditDomainLanguageModalOpen = getInteractionsProperty(_interactions.EDIT_DOMAIN_LANGUAGE_MODAL_OPEN);
exports.getIsEditDomainLanguageModalOpen = getIsEditDomainLanguageModalOpen;
var getIsRedirectToAffectedPagesModalOpen = getInteractionsProperty(_interactions.REDIRECT_TO_AFFECTED_PAGES_MODAL_OPEN);
exports.getIsRedirectToAffectedPagesModalOpen = getIsRedirectToAffectedPagesModalOpen;
var getIsUpdatePageUrlModalOpen = getInteractionsProperty(_interactions.UPDATE_PAGE_URL_MODAL_OPEN);
exports.getIsUpdatePageUrlModalOpen = getIsUpdatePageUrlModalOpen;
var getEditPageOptionsModalOpen = getInteractionsProperty(_interactions.EDIT_PAGE_OPTIONS_MODAL_OPEN);
exports.getEditPageOptionsModalOpen = getEditPageOptionsModalOpen;
var getNewDomainLanguage = getInteractionsProperty(_interactions.NEW_DOMAIN_LANGUAGE);
exports.getNewDomainLanguage = getNewDomainLanguage;
var getOldDomainLanguage = getInteractionsProperty(_interactions.OLD_DOMAIN_LANGUAGE);
exports.getOldDomainLanguage = getOldDomainLanguage;
var getPageForUrlEdit = getInteractionsProperty(_interactions.PAGE_FOR_URL_EDIT);
exports.getPageForUrlEdit = getPageForUrlEdit;
var getIsEditPageUrlsOpen = getInteractionsProperty(_interactions.EDIT_PAGE_URLS_OPEN);
exports.getIsEditPageUrlsOpen = getIsEditPageUrlsOpen;
var getIsEditPageUrlsTableOpen = getInteractionsProperty(_interactions.EDIT_PAGE_URLS_TABLE_OPEN);
exports.getIsEditPageUrlsTableOpen = getIsEditPageUrlsTableOpen;
var getEditPageUrlsTableIndex = getInteractionsProperty(_interactions.EDIT_PAGE_URLS_TABLE_INDEX);
exports.getEditPageUrlsTableIndex = getEditPageUrlsTableIndex;
var getAddPageToSitemapModalOpen = getInteractionsProperty(_interactions.ADD_PAGE_TO_SITEMAP_MODAL_OPEN);
exports.getAddPageToSitemapModalOpen = getAddPageToSitemapModalOpen;
var getPagesForSitemapIndex = getInteractionsProperty(_interactions.PAGES_FOR_SITEMAP_INDEX);
exports.getPagesForSitemapIndex = getPagesForSitemapIndex;
var getFilterForSitemap = getInteractionsProperty(_interactions.FILTER_FOR_SITEMAP);
exports.getFilterForSitemap = getFilterForSitemap;
var getDomainForSitemap = getInteractionsProperty(_interactions.DOMAIN_FOR_SITEMAP);
exports.getDomainForSitemap = getDomainForSitemap;
var getSitemapPageForEdit = getInteractionsProperty(_interactions.SITEMAP_PAGE_FOR_EDIT);
exports.getSitemapPageForEdit = getSitemapPageForEdit;